import {
    mapState,
    mapActions
} from 'vuex'
import viewName from '../constant.js'
import {
    getPaymentsList
} from '@/models/chooseToPay'
import {
    getOrderStatus,
    goDebitcard
} from '@/models/pay'
import {
    filter,
    throttle,
    pick
} from 'lodash'
import {
    // configWeixin,
    wxPaySdk,
    // formateUrl
} from 'utils/wxsdk'
// import {
//     getLoginInfo
// } from '../../utils/loginInfo'
// import {
//     getQueryString
// } from '@/utils/util'
// import { formateUrl } from '@/utils/util'
import TimerManager from '@/utils/timer'
import { setFirstPage } from '../../utils/session'
import { Cell, CellGroup, Radio, RadioGroup } from 'vant'
import appGuideDialog from '../../components/appGuideDialog/appGuideDialog.vue'
import { isWx } from '../../utils/ua'

export default {
    name: viewName.chooseToPay,
    components: {
        appGuideDialog,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
    },
    data () {
        return {
            PAY_TYPE: ['SDK_WEIXIN_PAY', 'JS_WEIXIN_PAY', 'JS_ALIPAY', 'DEBITCARD'],
            timerManager: '',
            nowTime: '',
            timestamp: 0,
            pay_status: 0, // 支付状态， 0：未支付， 1：支付，2：已取消（订单支付超时）， 用来判断是否要计算倒计时
            package_time: 0, // 套餐包支付倒计时，最多30分钟
            debit_count: 0, // 储值卡余额
            buttonStatus: {
                buttonLoading: false
            },
            order_price: '',
            sstore_info: '',
            pay_method_list: '',
            selected: 0,
            package_id: '', // 套餐包id => 营销活动
        }
    },
    computed: {
        ...mapState({
            appInfo: ({
                appInfo
            }) => appInfo,
            isWeixin: ({
                pay
            }) => pay.isWeixin
        }),
        isPackage () {
            return !!this.package_id || (this.$route.query.order_type === 'service_package')
        },
        // 订单类型, service_package: 营销服务套餐包, 空就是默认商品
        order_type () {
            return this.isPackage ? 'service_package' : this.$route.query.order_type
        },
        // 如果是套餐包支付成功就跳转到套餐包支付成功页面，其他跳转商品成功页
        toPaySucessPage () {
            return this.isPackage ? 'activityPayResult' : 'payResult'
        }
    },
    created () {
        this.package_id = this.$route.query.package_id
        this.changeRouteQuery()
        this.timerManager = TimerManager.getInstance()
        this.getPayments()
    },
    activated () {},
    mounted () {
        this.checkPayState()
        this.setAppClass({
            isAppend: true,
            className: 'bgGreyColor'
        })
        this.$emit('setHeader', {
            title: '选择支付方式',
            showHeader: true,
            showLeft: true,
        })
    },
    destroyed () {
        this.timerManager.end()
        // this.removeSession()
    },
    methods: {
        start (timestamp = this.timestamp) {
            this.timerManager.start(Number(timestamp), (status, data) => {
                if (status === 1) {
                    // 是否是套餐包
                    if (this.isPackage) {
                        this.overTimePay()
                    }
                } else {
                    this.nowTime = data
                }
            })
        },
        changeRouteQuery () {
            // 非微信环境
            if (!isWx()) {
                const reg = /^JS_WEIXIN_PAY/g
                const query = this.getSession()
                const route = this.$route
                // 有type证明是h5唤起微信进行支付返回当前页面，是从营销服务详情进来就还原支付之前当前页面参数，否则不用还原
                if (reg.test(route.query.type) && route.query.order_type && (route.query.order_type === 'service_package')) {
                    this.package_id = query.package_id
                    this.$router.replace({
                        path: '/chooseToPay',
                        query: {
                            ...query,
                            ...route.query
                        }
                    })
                }
            }
        },
        checkPayState () {
            let {
                query
            } = this.$route
            if (query.type) {
                // 弹窗询问
                this.$dialog
                    .confirm({
                        showCancelButton: true,
                        title: '提示',
                        message: '是否已支付完成?'
                    })
                    .then(async () => {
                        // 查询订单接口
                        if (query.order_id) {
                            getOrderStatus({
                                trade_no: query.trade_no
                            }).then(back => {
                                if (back.pay_status === 0) {
                                    this.$toast(back.status_msg)
                                } else {
                                    this.toPayResult()
                                }
                            })
                        }
                    }).catch(() => {})
            }
        },
        ...mapActions(['postUnifiedPayment', 'setAppClass']),
        // 调取接口
        async getPayments () {
            const data = await getPaymentsList({
                order_id: this.$route.query.order_id,
                order_type: this.order_type
                // token: this.appInfo.token || getLoginInfo()['token']
                // 因为跳出应用之后，vuex里面的都恢复到了初始值，所以要在缓存里面拿。
                // 后期优化，优化在routes里面判断vuex里面没有token则要获取缓存里面的token更新到vuex里面
            })
            const list = this.filterPayments(data.pay_method_list)
            const selected = this.findselected(list, data.order_price)
            const timestamp = data.timestamp
            const pay_status = Number(data.pay_status)
            Object.assign(this, {
                timestamp,
                selected,
                debit_count: data.debit_count,
                package_time: data.package_time,
                order_price: data.order_price,
                sstore_info: data.sstore_info,
                pay_status,
                pay_method_list: list
            })
            // 分销套餐包
            if (this.isPackage) {
                // 订单未支付 || 已取消支付
                if (pay_status === 0 || pay_status === 2) {
                    // 支付超时
                    if (data.package_time === 0) {
                        this.overTimePay()
                    } else {
                        this.start(data.package_time)
                    }
                }
            } else if (timestamp !== -1 && timestamp > 0) { // 非套餐包支付倒计时
                this.start(timestamp)
            }
        },
        // 缓存套餐包支付参数，便宜H5支付回来使用
        setSession () {
            const query = this.$route.query
            sessionStorage.setItem('package_query', JSON.stringify(query))
        },
        // 获取套餐包缓存
        getSession () {
            const query = sessionStorage.getItem('package_query') || '{}'
            return JSON.parse(query)
        },
        // 删除套餐包缓存参数
        removeSession () {
            sessionStorage.removeItem('package_query')
        },
        // 支付超时，bc营销V2.0新增
        overTimePay () {
            this.$dialog.alert({
                message: `<div class="overTime">支付超时，该订单已失效</div><div class="newBuy">请重新选择活动购买</div>`,
                confirmButtonText: '重新下单',
                confirmButtonColor: '#fc2d2d',
                className: 'pay-dialog',
                closeOnPopstat: true
            }).then(() => {
                const { sstore_id, package_id, distribution_code } = this.$route.query
                // 跳转营销服务详情页面
                this.$router.push({
                    path: '/marketingActivities',
                    query: {
                        sstore_id,
                        package_id,
                        distribution_code
                    }
                })
            })
        },
        // 找出默认的微信支付
        findselected (list, money) {
            let selected = ''
            const cardStatus = list.some(PayItem => PayItem.pay_type_code === 'DEBITCARD')
            // 若支持储值卡支付并且余额大于或者等于支付金额，默认选中储值卡支付
            if (cardStatus) {
                list.map(payWay => {
                    if (payWay.pay_type_code === 'DEBITCARD') {
                        // 若储值卡余额大于或者等于订单金额，可用储值卡支付，反之禁止使用储值卡支付(禁止操作写在html上了)
                        if (Number(payWay.debit_count) >= Number(money)) {
                            selected = 'DEBITCARD'
                        } else {
                            // 若储值卡余额不足以支付，目前只能使用微信支付，因为支付宝支付已过滤
                            selected = this.appInfo.isWeixin ? this.PAY_TYPE[0] : this.PAY_TYPE[1]
                        }
                    }
                })
            } else {
                // 在微信app内使用微信sdk支付，反之则使用微信h5支付
                selected = this.appInfo.isWeixin ? this.PAY_TYPE[0] : this.PAY_TYPE[1]
            }
            return selected
        },
        // 支付方式过滤
        filterPayments (data) {
            let filterkey = {
                // 过滤支付宝支付
                // h5: /^(JS_ALIPAY)|(JS_WEIXIN_PAY)|(DEBITCARD)$/,
                h5: /^(JS_WEIXIN_PAY)|(DEBITCARD)$/,
                weixin: /^(SDK_WEIXIN_PAY)|(DEBITCARD)$/
            }
            let envKey = this.appInfo.isWeixin ? 'weixin' : 'h5'
            const result = filter(data, payWay => filterkey[envKey].test(payWay.pay_type_code))
            return result
        },
        // 阿里支付
        aliPay (data) {
            // 表单操作
            const formWrapDom = this.$refs.payForm
            formWrapDom.innerHTML = data
            const formDom = formWrapDom.getElementsByTagName('form')[0]
            formDom.submit()
        },
        toPayResult () {
            this.timerManager.end()

            // 清空腾讯广告归因数据
            sessionStorage.removeItem('TENCENT_AD_ATTR')
            console.log('支付完成, 清空归因数据: ', sessionStorage.getItem('TENCENT_AD_ATTR'))

            let {
                query
            } = this.$route
            this.$router.replace({
                name: this.toPaySucessPage,
                query: {
                    order_id: query.order_id,
                    coupon_id: query.coupon_id,
                    order_type: this.order_type
                }
            })
        },
        // 微信sdkpay
        sdkWxPay (data) {
            wxPaySdk(data).then(res => {
                this.toPayResult()
            }).catch(err => {
                this.$dialog
                    .alert({
                        showCancelButton: true,
                        title: '提示',
                        message: err
                    })
            })
            // wx.chooseWXPay({
            //     appId: data.appId,
            //     timestamp: data.timeStamp,
            //     nonceStr: data.nonceStr,
            //     package: data.package,
            //     signType: data.signType,
            //     paySign: data.paySign,
            //     success: () => {
            //         // this.h5WeixinpayEnd(true, out_trade_no)
            //     },
            //     fail: () => {
            //         // this.h5WeixinpayEnd(false, out_trade_no)
            //     },
            //     cancel: () => {

            //     }
            // })
        },
        pay: throttle(function () {
            let {
                selected
            } = this
            if (selected) {
                this.buttonStatus.buttonLoading = true
                switch (selected) {
                // 储值卡支付
                case 'DEBITCARD':
                    this.$dialog.confirm({
                        title: '温馨提示',
                        message: `本次消费<span style="color: #fc2d2d">${this.order_price}</span>元将从您的储值卡余额中扣除`,
                        confirmButtonColor: '#fc2d2d',
                        className: 'debitcard-dialog',
                    }).then(() => {
                        // 进行储值卡支付
                        goDebitcard({order_id: this.$route.query.order_id}).then(() => {
                            this.buttonStatus.buttonLoading = false
                            this.toPayResult()
                        }).catch(() => {
                            this.buttonStatus.buttonLoading = false
                        })
                    }).catch(() => {
                        this.buttonStatus.buttonLoading = false
                    })
                    break
                default:
                    // 进行支付
                    // let URL = `${location.href}&type=${selected}`
                    this.postUnifiedPayment({
                        // redirect_h5_url: URL, // 由后端做处理
                        pay_type_code: selected,
                        order_id: this.$route.query.order_id,
                        order_type: this.order_type,
                        http_type: location.protocol // https: || http:
                    }).then(back => {
                        setTimeout(() => {
                            this.buttonStatus.buttonLoading = false
                        }, 2000)
                        if (!back) {
                            this.$toast('抱歉，暂不支持该方式支付。')
                            return
                        }
                        const route = pick(this.$route, ['path', 'name', 'query', 'fullPath', 'meta', 'title', 'hash'])
                        // const PAY_TYPE = ['SDK_WEIXIN_PAY', 'JS_WEIXIN_PAY', 'JS_ALIPAY']
                        if (selected === this.PAY_TYPE[0]) {
                            // 微信内部支付
                            this.sdkWxPay(back)
                        } else if (selected === this.PAY_TYPE[1]) {
                            // 微信H5外部支付
                            setFirstPage(route)
                            this.isPackage && this.setSession()
                            location.href = `${back.mweb_url}`
                        } else if (selected === this.PAY_TYPE[2]) {
                            // 阿里支付宝H5外部支付-使用form表单
                            setFirstPage(route)
                            this.aliPay(back.form_html)
                        }
                    }).catch(err => {
                        this.buttonStatus.buttonLoading = false
                        if (err.errcode === 1002) {
                            this.$toast({
                                message: '订单已经支付，请勿重复发起支付!',
                                position: 'bottom'
                            })
                            this.toPayResult()
                        }
                    })
                }
            }
        }, 1000),
        // 显示引导关注/下载 弹窗
        showModal (type, money) {
            // 储值卡余额不足，显示弹窗
            if (type === 'DEBITCARD' && Number(money) < Number(this.order_price)) {
                this.$refs.appGuideDialog.showStatus = true
            }
        }
    }
}
